interface FileTreeGuidesProps {
  path: string;
  depth: number;
  isLast: boolean;
  ancestorHasNextSiblings: boolean[];
  contentPaddingLeft: number;
}

const TREE_INDENT_WIDTH = 18;
const TREE_BASE_PADDING = 8;
const TREE_CONNECTOR_OFFSET = 9;

export const getTreeContentPaddingLeft = (depth: number, nodeType: "file" | "folder") =>
  TREE_BASE_PADDING + depth * TREE_INDENT_WIDTH + (nodeType === "folder" ? 4 : 0);

export const FileTreeGuides = ({
  path,
  depth,
  isLast,
  ancestorHasNextSiblings,
  contentPaddingLeft,
}: FileTreeGuidesProps) => {
  if (depth === 0) {
    return null;
  }

  const ancestorGuideColumns = ancestorHasNextSiblings.reduce<number[]>(
    (columns, hasNextSibling, index) => {
      if (hasNextSibling) {
        columns.push(TREE_BASE_PADDING + index * TREE_INDENT_WIDTH + TREE_CONNECTOR_OFFSET);
      }

      return columns;
    },
    [],
  );
  const connectorColumn =
    TREE_BASE_PADDING + (depth - 1) * TREE_INDENT_WIDTH + TREE_CONNECTOR_OFFSET;
  const connectorWidth = Math.max(contentPaddingLeft - connectorColumn, 0);

  return (
    <div aria-hidden className="pointer-events-none absolute inset-y-0 left-0">
      {ancestorGuideColumns.map(column => (
        <span
          key={`ancestor-guide-${path}-${column}`}
          className="absolute inset-y-0 w-px bg-gray-200"
          style={{ left: `${column}px` }}
        />
      ))}
      <span
        className="absolute top-0 w-px bg-gray-200"
        style={{
          left: `${connectorColumn}px`,
          height: isLast ? "50%" : "100%",
        }}
      />
      <span
        className="absolute h-px bg-gray-200"
        style={{
          left: `${connectorColumn}px`,
          top: "50%",
          width: `${connectorWidth}px`,
        }}
      />
    </div>
  );
};
